import DateFunc from '@/lib/lyg/date_func';
import MyScreenFunc from '@/pcomponents/common/screen/func/screen_func';
import strFunc from '@/lib/lyg/string';

function SearchSupplyArea(props: any) {
  let myProps: any = {
    listOpt: {
      s_supply_date_type: 'a_date',
      s_supply_start_date: DateFunc.get_date_format(new Date(), "Y-m-01"),
      s_supply_end_date: DateFunc.get_date_format(new Date(), "Y-m-t"),
      s_supply_state: "",
      s_supply_sort: "",
    },
    goWriteSupply: () => { },
    open_supply_custom_popup: () => { },
    list: (listOpt: any) => { },
    ...props
  };
  let listOpt = myProps.listOpt;
  let is_under_width = MyScreenFunc.get_is_under();

  const onChangeDatePicker = (key: string, date: Date) => {
    let date_str = DateFunc.get_date_format(date, "Y-m-d");
    myProps.list({
      now_page: "1",
      ...{ [key]: date_str }
    });
  };

  const handleInputChange = (event: any) => {
    const target = event.target;
    let value = target.value;
    const name = target.name;

    myProps.list({
      now_page: "1",
      ...{ [name]: value }
    });
  };

  const goDateMonthChange = (sort: any) => {
    //next,pre
    let selected_date = listOpt.s_supply_start_date;
    if (selected_date == "") {
      selected_date = DateFunc.get_date_format(new Date(), "Y-m-d");
    }
    let change_date_obj = new Date(selected_date);
    if (sort == "pre") {
      change_date_obj = DateFunc.get_change_date(new Date(selected_date), 'month', -1);
    } else if (sort == "next") {
      change_date_obj = DateFunc.get_change_date(new Date(selected_date), 'month', +1);
    }

    let start_date = DateFunc.get_date_format(change_date_obj, "Y-m-01");
    let end_date = DateFunc.get_date_format(change_date_obj, "Y-m-t");
    myProps.list({
      now_page: "1",
      s_supply_start_date: start_date,
      s_supply_end_date: end_date,
    });
  };

  const goChangeDateMonth = (month: number) => {
    let selected_date = listOpt.s_supply_start_date;
    if (selected_date == "") {
      selected_date = DateFunc.get_date_format(new Date(), "Y-m-d");
    }
    let row_year = selected_date.substring(0, 4);
    let row_month = strFunc.str_pad({ "str": month, "pad_length": 2 });
    selected_date = row_year + "-" + row_month + "-01";

    let start_date = DateFunc.get_date_format(new Date(selected_date), "Y-m-01");
    let end_date = DateFunc.get_date_format(new Date(selected_date), "Y-m-t");
    myProps.list({
      now_page: "1",
      s_supply_start_date: start_date,
      s_supply_end_date: end_date,
    });
  };

  let right_box_class_name = "absolute right-0 top-0 btn-box-left";
  if (is_under_width) {
    right_box_class_name = "";
  }

  let year_month_num_arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  return (
    <div>
      <div className="btn-box-left relative">
        <span className="text-blue-900">
          {listOpt.s_supply_start_date.substring(0, 4)} 년
        </span>
        <span className="text-blue-700 ml-1">
          {listOpt.s_supply_start_date.substring(5, 7)} 월
        </span>
        <select className="search-input_select" name="s_supply_date_type" value={listOpt.s_supply_date_type} onChange={handleInputChange} >
          <option value="a_date">청구일</option>
        </select>
        {year_month_num_arr.map((row_num) => {
          let btn_class_name = "btn btn-dark ml-1";
          let select_month_num = parseInt(listOpt.s_supply_start_date.substring(5, 7));
          if (select_month_num == row_num) {
            btn_class_name = "btn btn-blue ml-1";
          }
          return (
            <button key={row_num} className={btn_class_name}
              onClick={() => { goChangeDateMonth(row_num); }} >{row_num}</button>
          );
        })}
        <button className="btn-s btn-dark" onClick={() => { goDateMonthChange("pre"); }} >◀</button>
        <button className="btn-s btn-dark" onClick={() => { goDateMonthChange("next"); }} >▶</button>
        <select className="search-input_select" name="s_supply_state" value={listOpt.s_supply_state} onChange={handleInputChange} >
          <option value="">수납상태</option>
          <option value="complete">완납</option>
          <option value="unpay">미납</option>
        </select>
        <select className="search-input_select" name="s_supply_sort" value={listOpt.s_supply_sort} onChange={handleInputChange} >
          <option value="">수납구분</option>
          <option value="class">수업</option>
          <option value="etc">기타</option>
        </select>
        <div className={right_box_class_name}>
          <button className="btn btn-blue"
            onClick={() => {
              myProps.goWriteSupply({});
            }}>선택수납추가</button>
          <button className="btn btn-dark ml-1" onClick={myProps.open_supply_custom_popup}>수동수납추가</button>
        </div>
      </div>
    </div>
  );
}
export default SearchSupplyArea;